<div class="ontario-row">
  <div class="ontario-column">
    <h1 class="page-title">{{'Tab.ApprovedTrainingProviders' | translate}}</h1>
  </div>
  <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-3 provider-input-section">
    <label for="TrainingProvider" class="input-label">{{'Marketplace.TrainingProvider' | translate}}</label>
    <input id="TrainingProvider" type="text" placeholder="{{'Marketplace.TrainingProviderPlaceholder' | translate}}"
      class='input-text' matInput [(ngModel)]="trainingProviderSearchForm.trainingProviderName" [matAutocomplete]="auto"
      [formControl]="trainingProviderControl">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        @for (option of filteredProviderOptions; track option) {
          <mat-option [value]="option">
            {{option.ApplicantBusinessOperatingName}}
          </mat-option>
        }
      </mat-autocomplete>
    </div>
    <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-3">
      <app-dropdown [label]="'Marketplace.TrainingProgram' | translate" [currentLang]="currentLang"
        [options]="trainingProgramOptions" [(formValue)]="trainingProviderSearchForm.trainingProgramId">
      </app-dropdown>
    </div>
    <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-6 ">
      <fieldset>
        <legend><label class="input-label blocked">{{"Marketplace.TrainingType" | translate}}</label></legend>
        @for (type of trainingTypes; track type) {
          <button class="training-type-button"
            [class.selected]="trainingTypeIdSelected.indexOf(type.TrainingTypeId) > -1"
            [attr.aria-pressed]="trainingTypeIdSelected.indexOf(type.TrainingTypeId) > -1 ? 'true' : 'false'"
            (click)="addToSelectedTypeId(type.TrainingTypeId)">
            {{currentLang == 'en' ? type.Name : type.NameFr}}
          </button>
        }
      </fieldset>
    </div>
    <div class="ontario-column form-input-div ontario-small-12 ontario-medium-6 ontario-large-3">
      <app-dropdown [label]="'TrainingProviderSearch.CPOapprovalstatus' | translate" [currentLang]="currentLang"
      [options]="cpoApprovalStatusOptions" [(formValue)]="trainingProviderSearchForm.cpoApprovalStatus"></app-dropdown>
    </div>
    <div class="button-row ontario-column ontario-small-12 ontario-medium-12">
      <button id="search-button" (click)="searchTrainingProviders()">
        {{'Marketplace.Search' | translate}}
      </button>
      <button id="reset-button" (click)="initSearchForm()" class="ontario-button ontario-button--tertiary">
        {{'Marketplace.ResetFilters' | translate}}
      </button>
      <hr class="bolder-hr">
      <div class="showing-row" role="status">{{'TrainingProviderSearch.Showing' | translate}}
        {{trainingProviderSearchResults == null ? 0 : trainingProviderSearchResults.length}}
      {{'TrainingProviderSearch.ProvidersInfo' | translate}}</div>
    </div>
  </div>
  <div class="page-content ontario-row results-row">
    <div class="ontario-column ontario-small-12">
      <div class="table">
        <div class="table-row">
          <div class="table-col header-col provider-cell">
            <label for="provider-name">{{'SafetyAndPrevention.ProviderName' | translate}}</label>
          </div>
          <div class="table-col header-col city-cell">
            <label for="city">{{'Address.CityTown' | translate}}</label>
          </div>
          <div class="table-col header-col address-cell">
            <label for="registered-address">{{'SafetyAndPrevention.RegisteredAddress' | translate}}</label>
          </div>
          <div class="table-col header-col contact-cell">
            <label for="contact">{{'SafetyAndPrevention.Contact' | translate}}</label>
          </div>
          <!-- <div class="table-col header-col offered-cell">
          <label for="offered-to">{{'SafetyAndPrevention.OfferedTo' | translate}}</label>
        </div> -->
        <div class="table-col header-col program-cell">
          <label for="offered-to">{{'SafetyAndPrevention.ProgramOffered' | translate}}</label>
        </div>
        <div class="table-col header-col expand-cell"></div>
      </div>

      @for (tp of trainingProviderSearchResults; track tp; let i = $index) {
        <div class="table-row" [class.tprow-greybg]="i % 2 == 1">
          <div class="table-col">
            <div class="column-val">
              {{tp.Name}}
            </div>
          </div>
          <div class="table-col city-cell">
            @if (tp.OfferingToType && tp.OfferingToType == 'Public') {
              <div class="column-val">
                {{tp.CityTown != null ? tp.CityTown : 'N/A'}}
                @if (tp.LocationCount>1) {
                  <p class="other-loc">
                    {{tp.LocationCount}} {{'SafetyAndPrevention.OtherLocations' | translate}}
                  </p>
                }
              </div>
            }
          </div>
          <div class="table-col">
            @if (tp.OfferingToType && tp.OfferingToType == 'Public') {
              <div class="column-val">
                <div [innerHTML]="tp.FormattedAddress"></div>
              </div>
            }
          </div>
          <div class="table-col contact-cell">
            @if (tp.OfferingToType && tp.OfferingToType == 'Public') {
              <div class="column-val" id="contact">
                @for (elecAddress of tp.ElectronicAddresses; track elecAddress) {
                  @if (!tpAppUtils.isNullOrEmpty(elecAddress.ElectronicAddressValue)) {
                    <p class="contact-list break-word"
                      >
                      {{elecAddress.TypeName[0]}}: {{elecAddress.TypeName[0] != 'P' ? (elecAddress.ElectronicAddressValue) : (elecAddress.ElectronicAddressValue | phone)}}
                    </p>
                  }
                }
                @if (!tpAppUtils.isNullOrEmpty(tp.WebSite)) {
                  <p class="contact-list break-word">
                    W: {{tp.WebSite}}
                  </p>
                }
                <!-- View Storefront functionality to be added after Release 1.1 -->
                <!-- <div>
                <a class="store-link"
                  [routerLink]="[currentLang == 'en' ? '/marketplace/course-search': '/fr/marketplace/course-search']"
                [queryParams]="{'tpId':tp.TrainingProviderId}">{{'SafetyAndPrevention.Storefront' | translate}}</a>
              </div> -->
            </div>
          }
        </div>
        <!-- <div class="table-col offered-cell">
        <div class="column-val">
          {{tp.OfferingToType == null ? 'N/A' : (currentLang == 'en' ? tp.OfferingToType : tp.OfferingToTypeFr)}}
        </div>
      </div> -->
      <div class="table-col program-cell">
        <div class="column-val">
          @if (tp.HasWAHApproval) {
            <p>{{'SafetyAndPrevention.WAH' | translate}}</p>
          }
          @if (tp.HasJHSCApproval) {
            <p>{{'SafetyAndPrevention.JHSC' | translate}}</p>
          }
        </div>
      </div>
      <div class="table-col expand-cell">
        <div class="column-val">
          <button [class.expanded]="tp.Expanded"
            [attr.aria-label]="tp.Expanded? 'Show less training provider information': 'Show more training provider information'"
            (click)="tp.Expanded = !tp.Expanded; getCourseApprovalData(tp, tp.Expanded)">
            @if (!tp.Expanded) {
              <img alt="expand" src="assets/images/chevron-down-black-grey-border.svg">
            }
            @if (tp.Expanded) {
              <img alt="collapse" src="assets/images/chevron-down-blue-border.svg">
            }
          </button>
        </div>
      </div>
    </div>
    @if (tp.Expanded) {
      <div class="table-row expanded-row" [class.tprow-greybg]="i % 2 == 1">
        <div class="table-col">
          <div class="column-val">
            <app-horizontal-radio-button-list [currentLang]="currentLang"
              [radioButtonOptions]="tp.TabOptions != undefined ? tp.TabOptions : []" [(value)]="tp.SelectedOption"
              (valueChange)="filterTPCourseApprovals(tp, tp.SelectedOption)">
            </app-horizontal-radio-button-list>
            <hr class="table-hr">
            <div class="table-row header-row">
              <div class="table-col header-col spacer"></div>
              <div class="table-col header-col">
                <label>{{'SafetyAndPrevention.ProgramOffered' | translate}}</label>
              </div>
              <div class="table-col header-col">
                <label>{{'SafetyAndPrevention.DeliveryMethod' | translate}}</label>
              </div>
              <div class="table-col header-col">
                <label>{{'SafetyAndPrevention.OfferedTo' | translate}}</label>
              </div>
              <div class="table-col header-col">
                <label>{{'SafetyAndPrevention.Language' | translate}}</label>
              </div>
              <div class="table-col header-col">
                <label>{{'SafetyAndPrevention.ApprovedOn' | translate}}</label>
              </div>
              <div class="table-col header-col centered">
                <label>{{'SafetyAndPrevention.ApprovalStatus' | translate}}</label>
              </div>
              <div class="table-col header-col spacer"></div>
            </div>
            @for (ca of tp.FilteredCourseApprovals; track ca) {
              <div class="table-row">
                <div class="table-col header-col spacer"></div>
                <div class="table-col">
                  <div class="column-val">
                    {{currentLang == 'fr' ? ca.TrainingProgramFullNameFr : ca.TrainingProgramFullName}}
                  </div>
                </div>
                <div class="table-col">
                  <div class="column-val">
                    {{currentLang == 'fr' ? ca.TrainingTypeNameFr : ca.TrainingTypeName}}
                  </div>
                </div>
                <div class="table-col">
                  <div class="column-val">
                    {{ca.ConsentOption == null ? ('SafetyAndPrevention.InHouse' | translate) : ( ca.ConsentOption == 1 ?
                    ('SafetyAndPrevention.Public' | translate) : ('SafetyAndPrevention.InHouse' | translate))}}
                  </div>
                </div>
                <div class="table-col">
                  <div class="column-val">
                    {{ca.IsFrench ? ('SafetyAndPrevention.French' | translate) : ('SafetyAndPrevention.English' |
                    translate)}}
                  </div>
                </div>
                <div class="table-col">
                  <div class="column-val">
                    {{ca.ApprovedOnDate | utcToLocalDateTime : 'dd MMM yyyy'}}
                  </div>
                </div>
                <div class="table-col">
                  <div class="column-val centered">
                    {{ca.RevokedDate == null ? ('Triage.Active' | translate) : ('Triage.NoLongerApproved' | translate)}}
                    @if (ca.RevokedDate != null) {
                      <div class="revoked-date">
                        {{ca.RevokedDate | utcToLocalDateTime : 'dd MMM yyyy'}}
                      </div>
                    }
                  </div>
                </div>
                <div class="table-col spacer">
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
</div>
</div>
<div class="page-content ontario-row results-row-mobile">
  <div class="ontario-column ontario-small-12">
    @for (tp of trainingProviderSearchResults; track tp; let i = $index) {
      <div class="ontario-row program-card" [class.tprow-greybg]="i % 2 == 1">
        <div class="first-row">
          <div class="column-question">
            <label for="provider-name">{{'SafetyAndPrevention.ProviderName' | translate}}:</label>
          </div>
          <div class="column-answer" id="provider-name">
            {{tp.Name}}
          </div>
        </div>
        <div>
          <div class="column-question">
            <label for="city">{{'Address.CityTown' | translate}}:</label>
          </div>
          <div class="column-answer" id="city">
            {{tp.CityTown != null ? tp.CityTown : 'N/A'}}
            @if (tp.LocationCount>1) {
              <p class="other-loc">
                {{tp.LocationCount}} {{'SafetyAndPrevention.OtherLocations' | translate}}
              </p>
            }
          </div>
        </div>
        <div>
          <div class="column-question">
            <label for="registered-address">{{'SafetyAndPrevention.RegisteredAddress' | translate}}:</label>
          </div>
          <div class="column-answer" id="registered-address" [innerHTML]="tp.FormattedAddress">
          </div>
        </div>
        <div>
          <div class="column-question">
            <label for="contact">{{'SafetyAndPrevention.Contact' | translate}}:</label>
          </div>
          <div class="column-answer" id="contact">
            @for (elecAddress of tp.ElectronicAddresses; track elecAddress) {
              <p class="contact-list break-word">
                {{elecAddress.TypeName[0]}}. {{elecAddress.ElectronicAddressValue}}
              </p>
            }
          </div>
        </div>
        <div>
          <div class="column-question">
            <label for="offered-to">{{'SafetyAndPrevention.OfferedTo' | translate}}:</label>
          </div>
          <div class="column-answer" id="offered-to">
            {{tp.OfferingToType == null ? 'N/A' : ( (currentLang == 'en' ? tp.OfferingToType : tp.OfferingToTypeFr))}}
          </div>
        </div>
        <div>
          <div class="column-question">
            <label for="program-offered">{{'SafetyAndPrevention.ProgramOffered' | translate}}:</label>
          </div>
          <div class="column-answer" id="program-offered">
            @if (tp.HasWAHApproval) {
              <span>{{'SafetyAndPrevention.WAH' |
              translate}}</span><br />
            }
            @if (tp.HasJHSCApproval) {
              <span>{{'SafetyAndPrevention.JHSC' | translate}}</span>
            }
          </div>
        </div>
        <div class="expand-cell-mobile">
          <button [class.expanded]="tp.Expanded"
            [attr.aria-label]="tp.Expanded? 'Show less training provider information': 'Show more training provider information'"
            (click)="tp.Expanded = !tp.Expanded; getCourseApprovalData(tp, tp.Expanded)">
            @if (!tp.Expanded) {
              <img alt="expand" src="assets/images/chevron-down-black-grey-border.svg">
            }
            @if (tp.Expanded) {
              <img alt="collapse" src="assets/images/chevron-down-blue-border.svg">
            }
          </button>
        </div>
        @if (tp.Expanded) {
          <div class="programs-container-mobile">
            <div class="column-val">
              <app-horizontal-radio-button-list [currentLang]="currentLang"
                [radioButtonOptions]="tp.TabOptions != undefined ? tp.TabOptions : []" [(value)]="tp.SelectedOption"
                (valueChange)="filterTPCourseApprovals(tp, tp.SelectedOption)">
              </app-horizontal-radio-button-list>
              <hr class="table-hr">
              @for (ca of tp.FilteredCourseApprovals; track ca) {
                <div class="first-row">
                  <div class="column-question">
                    <label for="program-name">{{'SafetyAndPrevention.ProgramOffered' | translate}}:</label>
                  </div>
                  <div class="column-answer" id="program-name">
                    {{currentLang == 'fr' ? ca.TrainingProgramFullNameFr : ca.TrainingProgramFullName}}
                  </div>
                </div>
                <div>
                  <div class="column-question">
                    <label for="training-type-name">{{'SafetyAndPrevention.DeliveryMethod' | translate}}:</label>
                  </div>
                  <div class="column-answer" id="training-type-name">
                    {{currentLang == 'fr' ? ca.TrainingTypeNameFr : ca.TrainingTypeName}}
                  </div>
                </div>
                <div>
                  <div class="column-question">
                    <label for="training-language">{{'SafetyAndPrevention.Language' | translate}}:</label>
                  </div>
                  <div class="column-answer" id="training-language">
                    {{ca.IsFrench ? ('SafetyAndPrevention.French' | translate) : ('SafetyAndPrevention.English' |
                    translate)}}
                  </div>
                </div>
                <div>
                  <div class="column-question">
                    <label for="approved-date">{{'SafetyAndPrevention.ApprovedOn' | translate}}:</label>
                  </div>
                  <div class="column-answer" id="approved-date">
                    {{ca.ApprovedOnDate | utcToLocalDateTime : 'dd MMM yyyy'}}
                  </div>
                </div>
                <div>
                  <div class="column-question">
                    <label for="approved-date">{{'SafetyAndPrevention.ApprovalStatus' | translate}}:</label>
                  </div>
                  <div class="column-answer" id="approved-date">
                    {{ca.RevokedDate == null ? ('Triage.Active' | translate) : ('Triage.NoLongerApproved' | translate)}}
                    @if (ca.RevokedDate != null) {
                      <div class="revoked-date">
                        {{ca.RevokedDate | utcToLocalDateTime : 'dd MMM yyyy'}}
                      </div>
                    }
                  </div>
                </div>
                <hr class="table-hr">
                <div class="table-col spacer">
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>